// key <id> = api response data key
export const TASK_MODEL = {
  id: { id: 'id', label: 'id' },
  severity: {
    id: 'severity',
    label: 'severity',
  },
  severityRating: {
    id: 'severityRating',
    label: 'severityRating',
  },
  taskType: {
    id: 'taskType',
    label: 'Task Type',
  },
  taskCategory: {
    id: 'taskCategory',
    label: 'Category',
  },
  taskTypeID: {
    id: 'taskTypeID',
    label: 'Task Type ID',
  },
  taskSite: {
    id: 'site.name', // if the property you are looking for is in an object,
    //then it can be assigned like this and aggrid will find it. Here site is an object and name is a property key inside it.
    label: 'Site',
  },
  taskName: {
    id: 'name',
    label: 'Task Name',
  },
  startedByID: {
    id: 'startedByID',
    label: 'startedById',
  },
  startedByName: {
    id: 'startedByFullName',
    label: 'Started By',
  },
  finishedByID: {
    id: 'finishedByID',
    label: 'finishedByID',
  },
  finishedByName: {
    id: 'finishedByFullName',
    label: 'Finished By',
  },
  numSchedule: {
    id: 'numberOfSchedules',
    label: 'Schedule',
  },
  numEvidence: {
    id: 'numberOfEvidences',
    label: 'Evidence',
  },
  numSubtask: {
    id: 'numberOfSubtasks',
    label: 'Sub Tasks',
  },
  businessClientId: {
    id: 'businessClientId',
    label: 'Business Client ID',
  },
  businessClient: {
    id: 'id',
    businessClientId: {
      id: 'businessClientId',
      label: 'Business Client ID',
    },
    name: {
      id: 'name',
      label: 'Business Client Name',
      field: 'businessClientName',
    },
  },
  siteId: {
    id: 'siteId',
    label: 'Site ID',
  },
  site: {
    id: 'id',
    name: { id: 'name', field: 'siteName', label: 'Site Name' },
    siteId: { id: 'siteId', label: 'Site ID' },
  },
  timeStarted: {
    id: 'timeStarted',
    label: 'Start Time',
  },
  timeEnded: {
    id: 'timeFinished',
    label: 'Finish Time',
  },
  elapsedTime: {
    id: 'elapsedTime',
    label: 'Elapsed Time',
  },
  assignee: {
    id: 'assigneeId',
    label: 'Assignee',
  },
  assigneeFullName: {
    id: 'assigneeFullName',
    label: 'Assignee',
    field: 'assignee',
  },
  assigneeImageUrl: {
    id: 'assigneeImageUrl',
  },
  status: {
    id: 'status',
    label: 'Status',
  },
  description: {
    id: 'description',
    label: 'Description',
  },
  surfaceU: {
    id: 'surfaceU',
  },
  surfaceV: {
    id: 'surfaceV',
  },
  evidence: {
    id: 'evidence',
    label: 'Evidence',

    type: { id: 'type', label: 'Type' },
    description: { id: 'description', label: 'Description' },
    contents: { id: 'contents' },
    completed: { id: 'completed' },
    timestamp: { id: 'timestamp' },
  },
  descriptionImageUrl: {
    id: 'descriptionImageUrl',
  },
  expectedDuration: {
    id: 'expectedDuration',
    label: 'Expected Duration',
  },
  isTemplate: {
    id: 'isTemplate',
  },
  wrapsId: {
    id: 'wrapsId',
  },
  scanCode: {
    id: 'scanCode',
  },
  templateId: {
    id: 'templateId',
  },
  scanAutoStart: {
    id: 'scanAutoStart',
  },
  scanStartOnly: {
    id: 'scanStartOnly',
  },
  surfaceViewPreferred: {
    id: 'surfaceViewPreferred',
  },
  schedule: {
    id: 'schedule',
    label: 'Schedule',

    finishBefore: { id: 'finishBefore', label: 'Finish Before' },
    startAfter: { id: 'startAfter', label: 'Start After' },
    taskId: { id: 'taskId' },
  },
  schedulePatterns: {
    id: 'schedulePatterns',
    label: 'Schedule Patterns',

    scheduleType: { id: 'scheduleType', label: 'Schedule Type' },
  },

  surfaceId: { id: 'surfaceId' },
  subTasks: { id: 'subTasks', label: 'Sub Tasks' },
};

export const TASK_SCHEDULE_MODEL = {
  id: { id: 'id' },
  daysOfMonth: {
    id: 'daysOfMonth',
  },
  daysOfWeek: {
    id: 'daysOfWeek',
  },
  finishBefore: {
    id: 'finishBefore',
  },
  intervalInMinutes: {
    id: 'intervalInMinutes',
  },
  repeatUntil: {
    id: 'repeatUntil',
  },
  startAfter: {
    id: 'startAfter',
  },
  timezone: {
    id: 'timezone',
  },
  assignToUserIDs: { id: 'assignToUserIDs' },
};
